'use strict';

var _ = require('lodash');
var SystemStatusMarketReoptRetrieverService = function SystemStatusMarketReoptRetrieverService(app, restangular, momentService, liteDataService, searchCriteriaService, currentStateCriteriaService, searchCriteriaRsqlQueryService, userProcessingTransformationService) {
  var GRID_ID = 'system-status-market-reopt';
  function getLimit() {
    var queryConfig = _.find(app.dataRetrievalConfigs, {
      attributes: {
        view: 'SYSTEM_STATUS',
        mode: 'MARKET_REOPT'
      }
    });
    var soft = _.get(queryConfig, ['properties', 'softLimit']);
    var hard = _.get(queryConfig, ['properties', 'maxLimit']);
    return _.min([soft, hard]);
  }
  function getFilters() {
    return searchCriteriaService.getDefault(GRID_ID).then(function (defaultCriteria) {
      var searchCriteria = currentStateCriteriaService.getSearchCriteria();
      if (searchCriteria.context !== GRID_ID) {
        searchCriteria = defaultCriteria;
      }
      return searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(searchCriteria.rules);
    });
  }
  function getData() {
    return getFilters().then(function (rsqlFilter) {
      var request = {
        filter: rsqlFilter,
        maxLimit: getLimit()
      };
      return restangular.one('queue').one('BomMDRequest').one('messages').one('bomQueue').get(request);
    });
  }
  function transformData(data) {
    for (var index = 0, len = data.length; index < len; index++) {
      var dataRow = data[index];
      dataRow.userName = userProcessingTransformationService.getUserDisplayName(dataRow.userName);
      if (dataRow.departureDate) {
        dataRow.departureDate = momentService.of(dataRow.departureDate, momentService.FIELD.DEPARTURE_DATE);
      }
      if (dataRow.creationDate) {
        dataRow.creationDate = momentService.of(dataRow.creationDate, momentService.FIELD.CREATED_DATE);
      }
      if (dataRow.startDate) {
        dataRow.startDate = momentService.of(dataRow.startDate, momentService.FIELD.CREATED_DATE);
      }
      if (dataRow.completionDate) {
        dataRow.completionDate = momentService.of(dataRow.completionDate, momentService.FIELD.COMPLETED_DATE);
      }
    }
    return data;
  }
  function cancelOptimization(messageIds) {
    return restangular.one('domain/marketdemand/reoptimization/market').remove({
      messageKeys: messageIds
    });
  }
  return {
    getData: getData,
    transform: transformData,
    cancelOptimization: cancelOptimization
  };
};
SystemStatusMarketReoptRetrieverService.$inject = ['App', 'Restangular', 'MomentService', 'LiteDataService', 'SearchCriteriaService', 'CurrentStateCriteriaService', 'SearchCriteriaRsqlQueryService', 'UserProcessingTransformationService'];
module.exports = SystemStatusMarketReoptRetrieverService;